export default function Loading({ what = 'your class' }: { what?: string }) {
  return <div className="notice">Loading {what}…</div>;
}
